import { useEffect, useState } from "react";
import { useGetMyAbsenceStatsQuery } from "../api/absenceReportApiSlice";
import TimeOffCalendar from "../views/TimeOffCalendar";
import { getFirstTimestampOfMonth, getLastTimestampOfMonth } from "../../../../utility/MonthTimeUility";



export default function MyAbsenceCalendar() {

    // Stati per le date di inizio e fine del mese
    const [startDate, setStartDate] = useState(getFirstTimestampOfMonth());
    const [endDate, setEndDate] = useState(getLastTimestampOfMonth());

    // Query API
    const {
        data: absenceReportsUi,
        isSuccess: isAbsentsSuccess,
        isFetching: isAbsentsFetching,
        isError: isAbsentsError,
        error: absentsError,
        refetch: refetchAbsents
    } = useGetMyAbsenceStatsQuery({ start: startDate, end: endDate });

    // Effetto per aggiornare la query quando le date cambiano
    useEffect(() => {
        refetchAbsents(); // Ricarica i dati quando le date cambiano
    }, [startDate, endDate]);

    // Funzione per gestire il cambio mese
    const handleMonthChange = (start, end) => {
        console.log("MonthChanged")
        setStartDate(start);
        setEndDate(end);
    };

    return <TimeOffCalendar
        data={isAbsentsSuccess ? absenceReportsUi.absences : null}
        isFetching={isAbsentsFetching}
        isSuccess={isAbsentsSuccess}
        refetch={handleMonthChange}
    />

}

